import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux"
import moment from "moment";

import { Modal, Icon, Tabs, Checkbox, Button } from "antd";
import { Http } from "../../../../../../helpers/axois";

// import "./css/app.css"
import style from "../../../../Assisted/forms/list.module.sass";
import Service from "../../../assistedService/Service";
import SoloService from "../../../../Solo/soloService/Service"
import { selectedServices, ModalSelectedValue } from "../../../../../../stateManager/store/solo/action";
import { AppState } from "../../../../../../stateManager/store";
import SearchBar, { highlightMatch } from "../../../../../../helpers/SearchBar";

const { TabPane } = Tabs;

interface FormmodelProps {
  visible: boolean;
  getForms?: () => void;
  setvisible: (status: boolean) => void;
  appId: any;
  branchId: any;
  // editInitialData?: {};
  editable?: boolean;
  editType?: any;
  soloSelectedNodeId?: string;
  appVersion: { currentVersion: boolean; versionId: string };
  // getSavedForm: (Saveform: any, select?: string) => void
  selectedKey?: string;
  getService: (res: any, select?: string) => void;
  getSoloService: (res: any, select?: string) => void;
}
let onSubmit: any;
export const ServiceModal = ({
  visible,
  setvisible,
  appId,
  branchId,
  appVersion,
  soloSelectedNodeId,
  // editInitialData,
  editable,
  // getSavedForm,
  selectedKey,
  editType,
  getService,
  getSoloService
}: FormmodelProps) => {
  let [service, setservice]: any = useState([]);
  let [selFrom, setSelFrom]: any = useState("");
  let [activeTab, setActiveTab]: any = useState("1");
  const dispatch = useDispatch()
  const { selectedService } = useSelector((state: any) => state.solo);
  const { guideVisible, info: onboardingInfo } = useSelector((state: AppState) => state.onboarding)
  const  userName = useSelector((state: AppState) => state.user.data.user.userName);
  const [filteredData, setFilterData] = useState<any[]>([])
  const searchRef = useRef<{ clearSearch: () => void }>(null);
  const [searchValue, setSearchValue] = useState<string>("")

  const SoloServices = () => {
    getSoloService && getSoloService([selFrom], "select")
    dispatch(ModalSelectedValue({
      id: soloSelectedNodeId,
      name: selFrom && selFrom.name,
      key: selFrom && selFrom.serviceKey,
      type: selFrom && selFrom.serviceKey !== "" ? "custom" : ""
    }))
    setvisible(false);
  }

  const column = [
    {dataIndex: "name"},
    {dataIndex: "updatedAt"},
    {dataIndex: "createdBy"}
  ]
  
  useEffect(() => {
    // const currentVersion = appVersion && appVersion.currentVersion;  
    const versionId = appVersion && appVersion.versionId;
    if (selectedService !== "solo") {
      Http.get(`/apps/${appId}/services?versionId=${versionId}&branchId=${branchId}`).subscribe((serviceRes: any) => {
        selectedKey &&
          serviceRes.map((item: any) => {
            if (item.serviceKey === selectedKey) {
              setSelFrom(item);
            }
            return 0;
          });
        setFilterData(serviceRes)
        setservice(serviceRes);
      });
    }
    if (selectedService === "solo") {
      Http.get(`apps/${appId}/solo-services?versionId=${versionId}`).subscribe((res: any) => {
        selectedKey &&
          res.services.map((item: any) => {
            if (item.serviceKey === selectedKey) {
              setSelFrom(item);
            }
            return 0;
          });
        setFilterData(res.services)
        setservice(res.services)
      })
    }
  }, [appId, appVersion, selectedKey, branchId, selectedService]);

  useEffect(() => {
    if (soloSelectedNodeId) {
      dispatch(ModalSelectedValue({
        id: soloSelectedNodeId,
        name: selFrom && selFrom.name,
        key: selFrom && selFrom.serviceKey,
        type: selFrom && selFrom.serviceKey ? "custom" : ""
      }))
    }
  }, [selFrom, soloSelectedNodeId, dispatch])

  useEffect(()=>{
    if (guideVisible) {
      setActiveTab("2")
    }
  },[])

  return (
    <Modal
      data-test-id="bpmn_create_modal"
      width={676}
      maskClosable={false}
      className={`${style.model} OpenFormModal Bpmn_Create_Modal card-container`}
      bodyStyle={{
        height:'calc(100vh - 300px)',
        overflowY: "auto"
      }}
      title={
        <div className={style.searchModalHeader}> 
          Service Task
          {activeTab == '1' && (
            <SearchBar
              mode="modal"
              ref={searchRef}
              data={service}
              columns={column}
              onFilter={(filteredData ) => {
                setFilterData(filteredData)
              }}
              onSearchTermChange={ (searchValue: string)=>{ setSearchValue(searchValue) } }
            />
          )}
        </div>
      }
      onCancel={() => {
        setvisible(false);
      }}
      closeIcon={<Icon data-test-id="close" style={{ color: "white" }} type="close" />}
      destroyOnClose={true}
      footer={[
        <div key={"footer-1"}>
          <Button data-test-id="cancel" type="link" style={{ color: "#8797a8" }} onClick={() => { setvisible(false); dispatch(ModalSelectedValue(null)) }}>
            Cancel
          </Button>
          <Button
            data-test-id="create"
            //type="primary"
            disabled={activeTab === "1" ? (selFrom ? false : true) : false}
            className="modal-create-Button service_creation_save"
            onClick={() => {
              selectedService !== "solo" && dispatch(selectedServices("Assisted"))
              activeTab === "2" ? onSubmit() : selectedService === "solo" ? SoloServices() : getService([selFrom], "select");
            }}
          >
            {activeTab === "2" ? "Save" : selFrom.serviceKey === selectedKey ? "Open" : "Select"}
          </Button>
        </div>,
      ]}
      visible={visible}
    >
      <Tabs
        data-test-id="service_tab"
        defaultActiveKey={ guideVisible ? "2": "1" }
        onChange={(activeKey: string) => {
          searchRef.current?.clearSearch()
          setActiveTab(activeKey);
        }}
      >
        <TabPane tab={<div style={{ textAlign: "center", width: "240px" }}>Choose Service</div>} key="1">
          {filteredData.length > 0 ?
            <div className="choose-card-tab">
              {filteredData.map((item: any, key: number) => {
                let { name, updatedAt, createdBy, id, createdAt } = item;
                return (
                  <div className="choose-card-main" key={key}>
                    <div className="choose-card-checkbox">
                      <Checkbox
                        data-test-id={`modal_checkbox${key}`}
                        className="modal-Checkbox"
                        checked={selFrom.id === id}
                        onChange={() => {
                          selFrom.id === id ? setSelFrom("") : setSelFrom(item);
                        }}
                      ></Checkbox>
                    </div>
                    <div className="choose-card-main-inner">
                      <div className="choose-card-inner">
                        <div className="choose-card-Name">Service Name</div>
                        <div className="choose-card-value">{highlightMatch(name, searchValue)}</div>
                      </div>
                      <div className="choose-card-inner">
                        <div className="choose-card-Name">Last Modified</div>
                        <div className="choose-card-value">{highlightMatch(moment(updatedAt || createdAt).local().format("DD-MM-YYYY hh:mm a"),searchValue)}</div>
                      </div>
                      <div className="choose-card-inner" style={{ width: "100%" }}>
                        <div className="choose-card-Name">Created By</div>
                        <div className="choose-card-value">{highlightMatch(createdBy, searchValue)}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          : 
            <div className="flex items-center justify-center" style={{minHeight: "400px"}}>
              No Services Available
            </div>
          }
        </TabPane>
        <TabPane tab={<div style={{ textAlign: "center", width: "240px" }}>Create Service</div>} key="2">
          <div style={{ padding: "0px 0px 145px 0px" }}>
            {/* <Form
                            appId={appId}
                            getForms={getForms}
                            // editInitialData={editInitialData}
                            onSubmit={(submit: any) => (onSubmit = submit)}
                            getSavedForm={getSavedForm}
                            editable={editable}
                        ></Form> */}
            {selectedService !== "solo" ? <Service
              data-test-id="service"
              appId={appId}
              editType={editType}
              versionId={appVersion.versionId}
              getService={getService}
              setvisible={setvisible}
              // editInitialData={editInitialData}
              onSubmit={(submit) => (onSubmit = submit)}
              editable={editable}
            ></Service> :
              <SoloService
                data-test-id="service"
                appId={appId}
                editType={editType}
                versionId={appVersion.versionId}
                setvisible={setvisible}
                // editInitialData={editInitialData}
                onSubmit={(submit) => (onSubmit = submit)}
                editable={editable}
                getSoloService={getSoloService}
              />}
          </div>
        </TabPane>
      </Tabs>
    </Modal>
  );
};
